import { useQuery } from '@tanstack/react-query';
import { listEosTodos } from '../api';
import type { EosTodoFilters } from '../types';

export const eosTodoKeys = {
  all: ['eos-todos'] as const,
  list: (filters?: EosTodoFilters) => [...eosTodoKeys.all, 'list', filters ?? {}] as const,
  detail: (id: string) => [...eosTodoKeys.all, 'detail', id] as const,
};

export function useEosTodos(filters?: EosTodoFilters) {
  return useQuery({
    queryKey: eosTodoKeys.list(filters),
    queryFn: () => listEosTodos(filters),
  });
}
